
import { CplusDocumentSectionLabels } from '@/jbi-shared/types/document.types';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import { StagingEditorCommonMixin } from '../mixins/staging-editor-common.mixin';
import StagingDocumentNavigationTabs from './StagingDocumentNavigationTabs.vue';
import StagingEditorHeaderDocInfo from './StagingEditorHeaderDocInfo.vue';
import IconButton from '@/components/IconButton.vue';
import PendingProjectSettingsForm from './PendingProjectSettingsForm.vue';

@Component({
  components: {
    IconButton,
    StagingDocumentNavigationTabs,
    StagingEditorHeaderDocInfo
  }
})
export default class StagingEditorHeader extends mixins(
  StagingEditorCommonMixin
) {
  get displayedDocuments() {
    return this.pendingDocuments.map((doc) => {
      let tabDisplayTitle;
      if (!doc.documentId) {
        tabDisplayTitle = `Template ${CplusDocumentSectionLabels.RecommendedProcedure}`;
      } else {
        const existingProjectDocument = this.pendingProjectExistingProjectDocuments.find(
          (projectDocument) => projectDocument.id === doc.documentId
        );
        tabDisplayTitle = existingProjectDocument?.title;
      }
      return {
        ...doc,
        tabDisplayTitle
      };
    });
  }

  public openProjectSettings() {
    if (!this.documentDetail) {
      // Show loading toast if document not loaded yet
      this.$buefy.toast.open({
        message: 'Loading document details...',
        type: 'is-info',
        position: 'is-top'
      });
      return;
    }

    this.$buefy.modal.open({
      parent: this,
      component: PendingProjectSettingsForm,
      hasModalCard: true,
      trapFocus: true,
      props: {
        documentId: this.documentDetail.id
      }
    });
  }
}
